var map = {
	"./add-message.svg": 1387,
	"./chat-bubbles-with-ellipsis.svg": 1388,
	"./chat.svg": 1389,
	"./chatHistory.svg": 1390,
	"./chat_bubbles.svg": 1391,
	"./chatbotavatar1.svg": 1392,
	"./chatbotavatar2.svg": 1393,
	"./chatbotavatar3.svg": 1394,
	"./checked1.svg": 1395,
	"./comment.svg": 1396,
	"./comments.svg": 1397,
	"./congratulation.png": 1398,
	"./datatest": 1399,
	"./instal-chat.svg": 1400,
	"./last-widge-color.svg": 1401,
	"./lock2.svg": 1402,
	"./loginBg.png": 1403,
	"./logoutShoutDown.svg": 1404,
	"./send2.svg": 451,
	"./settingsNew.svg": 1405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1386;